import { useEffect } from "react";
import { useFormikContext } from "formik";

const AcademicYearSync = () => {
  const { values, setFieldValue } = useFormikContext();

  useEffect(() => {
    if (values.starts_at && values.ends_at) {
      const startYear = new Date(values.starts_at).getFullYear();
      const endYear = new Date(values.ends_at).getFullYear();
      const academicYear = `${startYear}-${String(endYear).slice(-2)}`;

      if (values.academic_year !== academicYear) {
        setFieldValue("academic_year", academicYear);
      }
    }
  }, [values.starts_at, values.ends_at]);

  return null;
};

export default AcademicYearSync;
